import $ from 'jquery';
import { isInt, isFloat, getHeaderHeight } from './functions';

const $document = $(document);
const $elToScroll = $('.page__body');

$document.on('click', '.smoothscroll', function (event) {
    const $thisEl = $(this);
    let selector;
    if ($thisEl.attr('href') !== undefined) {
        event.preventDefault();
        selector = $thisEl.attr('href');
    } else if ($thisEl.data('selector') !== undefined) {
        selector = $thisEl.data('selector');
    } else {
        return;
    }

    let offset = 0;
    if ($thisEl.data('offset') !== undefined) {
        offset = $thisEl.data('offset');
    }

    let animationDuration = 500;
    if ($thisEl.data('animduration') !== undefined) {
        animationDuration = $thisEl.data('animduration');
    }

    let elToScroll = $elToScroll;
    if ($thisEl.data('eltoscroll') !== undefined) {
        elToScroll = $thisEl.data('eltoscroll');
    }

    smoothscroll(selector, offset, animationDuration, elToScroll).then(function () {
        $thisEl.trigger('smoothscroll:end');
    });
});

export function smoothscroll(selector, offset = 0, animationDuration = 500, elToScroll = $elToScroll) {
    if ((isInt(offset) || isFloat(offset) || offset === 'header') && (isInt(animationDuration) || isFloat(animationDuration))) {
        return new Promise(function (resolve, reject) {
            let height;

            if (offset === 'header') {
                offset = getHeaderHeight();
            }
            if (typeof selector === 'string' || typeof selector === 'object' || selector instanceof $) {
                if (typeof selector === 'string' || typeof selector === 'object') {
                    selector = $(selector);
                }
                try {
                    height = selector.position().top + $elToScroll.scrollTop() - offset;
                } catch (e) {
                    console.log(e);
                    reject(e);
                }
            } else if (isInt(selector) || isFloat(selector)) {
                height = selector - offset;
            } else {
                reject('smoothscroll:selector:bad_type');
            }

            if (typeof elToScroll === 'string' || typeof elToScroll === 'object' || elToScroll instanceof $) {
                if (typeof elToScroll === 'string' || typeof elToScroll === 'object') {
                    elToScroll = $(elToScroll);
                }
            } else {
                reject('smoothscroll:elToScroll:bad_type');
            }

            scrollToHeight(height, animationDuration, elToScroll).then(function (message) {
                resolve(message);
            });
        });
    }
}

function scrollToHeight(height, animationDuration, elToScroll) {
    if (isInt(height) || isFloat(height)) {
        return new Promise(function (resolve, reject) {
            elToScroll.stop().animate(
                {
                    scrollTop: height,
                },
                animationDuration,
                function () {
                    resolve('smoothscroll:done');
                }
            );
        });
    }
}
